
import { GlobalConfirmationDialog } from "@/components/shared/global-confirmation-dialog"

export function ConfirmationProvider() {
  return <GlobalConfirmationDialog />
}
